import CashProcessingBatchBase from './base/CashProcessingBatchBase';

/**
 * @class CashProcessingBatch
 * @extends CashProcessingBatchBase
 */
class CashProcessingBatch extends CashProcessingBatchBase {
  get isProcessing() {
    return !!this.dateStarted && !this.dateEnded
  }

  get isProcessed() {
    return !!this.dateStarted && !!this.dateEnded
  }
}

export default CashProcessingBatch;
